export default __webpack_public_path__ + "static/2278-c58351f3c179365afd2c9f856eabdab2.gif";